import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { SimplePage } from "@/components/SimplePage";
import { useAuth, isMember } from "@/lib/auth";
import { errorText } from "@/lib/family";
import { Nice } from "@/components/Nice";
import { WhyNice } from "@/components/WhyNice";
import { Testimonials } from "@/components/Testimonials";

export default function AuthPage({ mode }) {
  const signup = mode === "signup";
  const { login, register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", agree: false });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      if (signup) { await register(f); nav("/subscribe"); }
      else { const u = await login(f.email, f.password); nav(isMember(u) ? "/" : "/subscribe"); }
    } catch (ex) { setErr(errorText(ex)); }
    setBusy(false);
  };

  return (
    <SimplePage testId={`${mode}-page`} back="/about" backLabel="About NICE" wide>
      <div className="pp-auth-layout">
      <div><WhyNice /><Testimonials className="mt-6" /><Link to="/get-the-app" className="pp-ghost mt-6" data-testid="auth-get-app-link">Get NICE on your phone</Link></div>
      <form className="pp-card max-w-md w-full" onSubmit={submit} data-testid={`${mode}-form`}>
        <p className="pp-label">{signup ? "Parents · create your account" : "Parents · welcome back"}</p>
        <h1 className="pp-h1 pp-sorry-title">{signup ? "Start your 3-day free trial" : "Sign in"}</h1>
        {signup && <p className="pp-sub">Then $7.99/month. Cancel anytime.</p>}
        {signup && <input className="pp-input pp-auth-input" placeholder="Your name" value={f.name} onChange={set("name")} data-testid="auth-name-input" required />}
        <input className="pp-input pp-auth-input" type="email" placeholder="Email" value={f.email} onChange={set("email")} data-testid="auth-email-input" required />
        <input className="pp-input pp-auth-input" type="password" placeholder={signup ? "Password (8+ characters)" : "Password"} value={f.password}
          onChange={set("password")} data-testid="auth-password-input" required minLength={signup ? 8 : 1} />
        {signup && (
          <label className="pp-agree" data-testid="auth-agree-label">
            <input type="checkbox" checked={f.agree} onChange={set("agree")} data-testid="auth-agree-checkbox" />
            <span>I am the parent or legal guardian creating this <Nice /> family account. I have read and agree to the <Link to="/terms" target="_blank" data-testid="auth-terms-link">Terms of Service</Link> and acknowledge the <Link to="/privacy" target="_blank" data-testid="auth-privacy-link">Privacy Policy</Link> and <Link to="/disclaimer" target="_blank" data-testid="auth-disclaimer-link">Disclaimer</Link>.</span>
          </label>
        )}
        {err && <p className="pp-feedback small" data-testid="auth-error">{err}</p>}
        <button className="pp-primary mt-5" disabled={busy || (signup && !f.agree)} data-testid="auth-submit-button">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : signup ? "Create account" : "Sign in"}
        </button>
        <p className="text-sm mt-5">
          {signup ? <>Already have an account? <Link to="/login" className="pp-link" data-testid="to-login-link">Sign in</Link></>
            : <>New to <Nice />? <Link to="/signup" className="pp-link" data-testid="to-signup-link">Create an account</Link></>}
        </p>
      </form>
      </div>
    </SimplePage>
  );
}
